export default __webpack_public_path__ + "910f916ec728e9c956e1936ab89abf15.svg";